import {
  Component,
  OnInit,
  ChangeDetectorRef,
  ViewChild,
  ElementRef,
  Renderer2,
  ViewEncapsulation,
} from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DateTime, Zone } from 'luxon';
import { GeneralService } from '../../../../services/general/general.service';
import { Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-index',
  templateUrl: './index.component.html',
  styleUrls: ['../../../../../shared-styles/wallet.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class IndexComponent implements OnInit {
  public isMobile: any;
  public headerHeight: any = 0;
  public amountAvailable: any = 0;
  public paginate: any = 0;
  public loading: any = false;
  public subscriptions: any = [];
  public dataSource = [];
  public displayedColumns: string[] = [
    'student',
    'date',
    'status',
    'type',
    'amount',
  ];
  
  public filter_wallet: any = "todos";
  public isTeacher = true;
  public walletLength: any = 0;
  public form: FormGroup;

  constructor(
    public general: GeneralService,
    private cdRef: ChangeDetectorRef,
    private renderer: Renderer2,
    private formBuilder: FormBuilder,
    private _router: Router,
    private _route: ActivatedRoute
  ) {
    // We create form
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });

    this.isMobile = this.general.isMobile();
  }

  async ngOnInit() {
    try {
      this.general.setLoading(true);
      window.dispatchEvent(new CustomEvent('calendar-hide-label'));
      this.intializeSubscriptions();
      await this.getWallet(this.filter_wallet);
      await this.getWalletAvailable();
    } catch (error) {
      // teacher-class-mine
    } finally {
      this.general.setLoading(false);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription: any) => {
      subscription.unsubscribe();
    });
  }

  intializeSubscriptions() {
    this.subscriptions = [
      this.general.loading$.subscribe((res) => (this.loading = res)),
    ];
  }

  // Handle event Listener
  handleEvent(event: any) {
    switch (event.type) {
    }
  }

  async getWallet(filter_id:any) {
    this.filter_wallet = filter_id;

    const response = await this.general.httpGet('wallet-mine', {
      page: this.paginate + 1,
      state: filter_id
    });
    this.dataSource = response.data.data.map((e: any) => {
      const timezone = this.general.getCurrentTimezone();
      const datetime = DateTime.fromISO(e.updated_at, {
        zone: 'UTC',
      }).setZone(timezone);

      const date = this.isMobile
        ? datetime.toFormat('dd/LL HH:mm')
        : datetime.toFormat('dd/LL/yyyy HH:mm');

      return {
        student: e.other_user.name,
        studentImage: e.other_user.profile_photo_path,
        date,
        type_product: e.type_product,
        amount: e.price,
        state: Number.parseInt(e.state),
        element: e,
      };
    });

    this.walletLength = response.data.total;
  }

  async getWalletAvailable() {
    const response = await this.general.httpGet('wallet-available');
    this.amountAvailable = response.data;
  }

  async onChangePage($event: any) {
    this.paginate = $event.pageIndex;
    await this.getWallet(this.filter_wallet);
  }

  async onActionClass(element: any, action: any) {
    try {
      this.general.setLoading(true);
      const response = await this.general.httpPost(
        'teacher-class-update-state',
        {
          action,
          id: element.id,
        }
      );

      let current: any = this.dataSource.find((e: any) => {
        return e.element.id === element.id;
      });

      if (current) {
        current.state = Number.parseInt(response.data.state);
      }
    } catch (error) {
      console.log(error);
    } finally {
      this.general.setLoading(false);
    }
  }

  // We check email is valid
  get emailNoValido() {
    return this.form.get('email')?.invalid && this.form.get('email')?.touched;
  }

  async withdraw() {
    try {
      /*await this.general.showDanger('paypal-failed');
      return;*/

      this.general.setLoading(true);

      await this.general.httpGet('payout/paypal', {
        email: this.form.value.email,
      });
      await this.general.showSuccess('withdraw-success');

      await this.getWallet(this.filter_wallet);
      await this.getWalletAvailable();
      // TODO Notify header that wallet value is changed
    } catch (error) {
      console.log(error);
      await this.general.showDanger('withdraw-error');
    } finally {
      this.general.setLoading(false);
    }
  }
}
